import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueLazyload from "vue-lazyload";
import wordCopy from "./components/wordCopy.vue";
import SchemaForm from '@vueblocks/element-schema-form'
import './directive.js';
import "./style.css";
import "./themes/theme-styles.css";
import "./styles/opsListShellEntry.js";
import { initCmsTheme } from "./themes/cmsThemeService";
import { patchElementDialog } from "./utils/patchElementDialog";
import { sortSelectOptions } from "./utils/sortSelectOptions";
import request from "./utils/request";
import { attachCloudAssetRetention, discardUnkeptCloudAssets } from "./utils/directCloudUpload";

attachCloudAssetRetention(request);
router.beforeEach((to, from, next) => {
  discardUnkeptCloudAssets();
  next();
});

initCmsTheme();
console.log("process.env.NODE_ENV:", process.env.NODE_ENV)


let resolveFun
let UI = new Promise((resolve, reject) => {
  store.dispatch('user/updateUserInfo')
  resolveFun = resolve
})
if (process.env.NODE_ENV === "development") {
  import('./assets/js/element').then(res => {
    Vue.use(res.default);
    resolveFun()
  })
} else {
  resolveFun()
}




UI.then(() => {
  patchElementDialog(Vue);
  Vue.prototype.$sortSelect = sortSelectOptions;
  Vue.use(SchemaForm)
  Vue.use(VueLazyload);
  Vue.component("word-copy", wordCopy);
  Vue.prototype.$bus = new Vue()
  Vue.prototype.$store = store
  Vue.config.productionTip = false;
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
})